import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { MultiSelectBuildProps } from 'components/molecules/MultiSelectBuild'
import { optionsDefault } from 'components/molecules/SelectBuild/constants'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { FormShippingFileKeys } from './types'

interface Schema {
    id: FormShippingFileKeys
}

export const FormReportValue = (
    UFDetran?: string
): Array<{
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    multiSelect?: MultiSelectBuildProps & Schema
    layout: LayoutProps
}> => {
    const checkUfToDetran = () => {
        return optionsDefault.ufContract.some((data) => data.value === UFDetran)
            ? UFDetran
            : ''
    }

    return [
        {
            input: {
                id: 'periodo',
                label: 'Período (Mês/Ano)',
                placeholder: 'mm/aaaa',
                type: 'month'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            multiSelect: {
                id: 'detran',
                label: 'DETRAN',
                optionsType: 'ufContract',
                defaultValue: checkUfToDetran(),
                isDisable: checkUfToDetran() === UFDetran
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'vencimento',
                label: 'Data de Vencimento',
                placeholder: 'dd/mm/aaaa',
                type: 'date'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        }
    ]
}
